// extracted by mini-css-extract-plugin
export default {"modalBody":"VideoModal_modalBody__32umq","divCardVideo":"VideoModal_divCardVideo__Xspm+"};